import { useMemo } from "react";

import { useRenameFolderMutation } from "@/graphql/folders/folders.hooks";
import { normalizeFolderName } from "@/utils/normalizeFolderName";

interface IUseRenameFolderOptions {
  onCompleted?: () => void;
  onError?: () => void;
}

interface IUseRenameFolderOptionsVariables {
  id: number;
  name: string;
}

function useRenameFolder({ onCompleted, onError }: IUseRenameFolderOptions) {
  const [renameFolder, { loading, error }] = useRenameFolderMutation({
    context: { errorType: "local" },
    onCompleted,
    onError,
  });

  return useMemo(
    () => ({
      renameFolder: async ({ id, name }: IUseRenameFolderOptionsVariables) => {
        await renameFolder({
          variables: {
            input: { id, name: normalizeFolderName(name) },
          },
        });
      },
      loading,
      error,
    }),
    [error, loading, renameFolder]
  );
}

export default useRenameFolder;
